import {Component, ViewChild, OnDestroy} from "@angular/core";
import {AdminForm} from "./admin-form.model";
import {AuthentService} from "../../services/authent.service";
import {BusinessService} from "../../services/data/business.service";
import {AdminListComponent} from "./admin-list/admin-list.component";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {Business} from "../../model/business";
import {Subscription} from "rxjs";

@Component({
  selector: 'admin-page',
  template: require('./admin-page.component.html'),
  styles: [
    require('./admin-page.component.scss')
  ]
})

export class AdminPageComponent implements OnDestroy {

  business: Business = new Business();

  adminForm: AdminForm = new AdminForm();
  formValid: boolean = false;
  canAdministrate: boolean = false;

  @ViewChild(AdminListComponent) child: AdminListComponent;

  private businessSubscription: Subscription = null;

  ngOnDestroy(): void {
    if (this.businessSubscription != null) {
      this.businessSubscription.unsubscribe();
    }
  }

  constructor(private authent: AuthentService, private businessService: BusinessService,
              private currentBusinessService: CurrentBusinessService) {
    if (authent.getRight() == null) {
      authent.userRight$.subscribe(
        right => {
          this.canAdministrate = right.canAdministrate;
        }
      );
    } else {
      this.canAdministrate = this.authent.getRight().canAdministrate;
    }

    if (currentBusinessService.currentBusiness != null &&
      currentBusinessService.currentBusiness.logoPath != null) {
      this.business = currentBusinessService.currentBusiness;
    } else {
      this.businessSubscription = currentBusinessService.businessChange$.subscribe(
        business => this.business = business
      )
    }
  }

  inviteAdmin(): void {
    this.businessService.addAdmin(this.currentBusinessService.currentBusiness.id, this.adminForm).subscribe(
      right => {
        this.adminForm = new AdminForm();
        this.child.loadAdmins();
      }
    )
  }

  sameEmail(): boolean {
    if (this.adminForm.email == this.adminForm.confirmEmail) {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/admin/admin-page.component.ts